import { ReactElement } from 'react';

import { DocplannerDoctorAddressMapping, DocplannerPractitioner } from '@dreryk/egabinet-docplanner-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { PractitionersSelect } from '../PractitionersSelect';

import { AddDoctorAssociationFormBean, AddDoctorAssociationFormController } from './addDoctorAssociation.types';
import { FacilitiesAssociationsInteractiveTable } from './FacilitiesAssociationsInteractiveTable';

type AddDoctorAssociationFormProps = {
   readonly practitioners: PractitionerView[];
   readonly associatedPractitioner: DocplannerPractitioner | undefined;
   readonly doctorAddressMappings: DocplannerDoctorAddressMapping[];
   readonly children: (props: { handleSubmit: AddDoctorAssociationFormController['handleSubmit'] }) => ReactElement;
};

export const AddDoctorAssociationForm = (props: AddDoctorAssociationFormProps): ReactElement => {
   const { register, handleSubmit } = useFormController<AddDoctorAssociationFormBean>({
      eGabinetPractitioner: props.associatedPractitioner,
      docplannerDoctorAddressMappings: props.doctorAddressMappings,
   });
   return (
      <StyledFlex as={'form'} direction={'column'} gap={'20px'} noValidate>
         <PractitionersSelect
            practitioners={props.practitioners}
            register={register}
            defaultValue={props.associatedPractitioner}
         />
         <FacilitiesAssociationsInteractiveTable register={register} />
         {props.children({ handleSubmit: handleSubmit })}
      </StyledFlex>
   );
};
